var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(90 16 16)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 16C8.00012 11.5888 11.5889 8 16.0001 8C17.7817 8 19.4679 8.57318 20.8766 9.6576L19.0176 12.0725C18.1466 11.4021 17.1031 11.0476 16.0001 11.0476C13.2694 11.0476 11.0477 13.2693 11.0477 16C11.0477 18.7307 13.2694 20.9524 16.0001 20.9524C18.1995 20.9524 20.0685 19.5114 20.7127 17.5238H16.0001V14.4762H24.0001V16C24.0001 20.4112 20.4113 24 16.0001 24C11.5889 24 8.00012 20.4112 8.00012 16Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.00012 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGoogle);
export default __webpack_public_path__ + "static/media/Footer-Google.d7c88350973909c33ebd2f626cfc0c12.svg";
export { ForwardRef as ReactComponent };